<div class="modal-body">
    <div class="d-flex justify-content-end" (click)="close()">
        <img src="assets/images/close_icon.svg" alt="">
    </div>
    <!-- modalContArea -->
    <div class="modalContArea" [formGroup]="form">
        <h4 class="mb-4">
            <img src="assets/images/ask-blakey-icon.svg" alt="">
            {{'Ask Blakey' | translate}}</h4>
        <!-- <p>{{'ruleAssistDesc' | translate}}</p> -->
        <p>David Blake is a <strong>LIV Golf rule Official</strong>, send him a question directly about your rule question</p>
        <p class="sm_txt my-3">
            <b>{{'Question' | translate}}</b><br>
            {{ruleAssistQuestionObject.question}}
        </p>
        <div class="email-wrap">
            <Label>{{'Your Email' | translate}}</Label>
            <input type="email" name="email" class="form-control" formControlName="email"
                [placeholder]="'Enter your email' | translate">
        </div>
        <textarea [readonly]="submitted" name="comment" class="form-control text-question" formControlName="comment"
                [placeholder]="'Type any golf rule question'| translate" autofocus></textarea>
        <a *ngIf="!submitted" href="javascript:void(0)" (click)="!submitting ? submit() : ''"
            class="btn common-btn blck">
            <ng-container *ngIf="!submitting">{{'Send' | translate}}</ng-container>
            <img *ngIf="submitting" class="btn-img" src="/assets/images/loading-btn.svg" />
        </a>
        <ng-container *ngIf="submitted">
            <p class="mt-4 mb-3">{{'ruleAssistPlaceholder' | translate}}</p>
            <a href="javascript:void(0)" (click)="close()" class="btn common-btn blck">{{'GoBackToHome'| translate}}</a>
        </ng-container>
    </div>
    <!-- modalContArea -->
</div>